<template>
<div>
	<table-list v-if="!invoiceOpen"
		record-name="Invoice"
		:fields="fields"
		:records="mutateInvoices($store.invoices,$store.project)"
		:has-edit="true"
		:clickable-row="true"
		v-on:edit="openInvoice"
		hide-record-count="true"
		id-field="slug">

		<div class="d-flex flex-row justify-content-between">
			<h2>
				Invoices<br>
				<small>Project #{{$store.project.job_num}}, {{$store.project.job_name}}</small>
			</h2>

			<div>
				<router-link class="btn btn-success ml-1" type="button" :to="'/project/'+$route.params.id+'/billing/new'">
					<i class="fa fa-file-invoice-dollar"></i>
					Draw Invoice
				</router-link>
			</div>
		</div>

	</table-list>

	<invoice v-else 
		v-on:closeInvoice="closeInvoice"
		v-on:invoiceDeleted="fetchInvoices"
		:invoice-slug="invoiceSlug"
		v-on:invoiceGenerated="setSlug">
	</invoice>
</div>
</template>
<script type="text/javascript">
import InvoiceMixins from "@/mixins/InvoiceMixins.js"

import Invoice from "./Invoice"
import TableList from "@/components/TableList"

export default {
	components: {
		Invoice,
		TableList
	},
	mixins: [InvoiceMixins],
	data() {
		return {
			invoiceOpen: false,
			invoiceSlug: null,
			fields: [
				{label: "Status",key:'status'},
				{label: "Invoice #",key: "invoiceNum"},
				{label: "Issue Date",key: "issueDate"},
				{label: "Before Tax", key: "beforeTaxTotal", align:"right"},
				{label: "Invoice Total", key: "invoiceTotal", align:"right"}
			]
		}
	},
	watch: {
		'$store.project'() {
			this.fetchInvoices()	
		}
	},
	computed: {
	},
	methods: {
		setSlug(slug) {
			this.invoiceSlug = slug
		},
		fetchInvoices() {
			this.fetchProjectInvoices(true,["JobInvoiceTask","JobChangeOrder"])
		},
		openInvoice(invoice) {
			this.$emit("invoiceOpened")
			this.invoiceSlug = invoice.slug
			this.invoiceOpen = true
			window.history.pushState({},"",'/project/'+this.$store.project.slug+'/billing/'+invoice.slug)
		},
		closeInvoice() {
			this.invoiceOpen = false
			this.$emit("invoiceClosed")
			this.$router.push('/project/'+this.$store.project.slug+'/billing/invoices')
		}
	},
	created() {
		if ("id" in this.$store.project)
			this.fetchInvoices()

		let urlSegs = this.segmentUrl(window.location.href)

		if (urlSegs.length == 5 && urlSegs[4] != 'invoices') {
			this.invoiceOpen = true
			this.invoiceSlug = this.$route.params.tag
			this.$emit("invoiceOpened")
		}
	}
}
</script>